// ============================================
// SAMPLE DRAWER - Flooring King
// ============================================

const SAMPLE_KEY = 'fk_samples';
const MAX_SAMPLES = 3;

function getSamples() {
  try {
    return JSON.parse(localStorage.getItem(SAMPLE_KEY)) || [];
  } catch { return []; }
}

function saveSamples(samples) {
  localStorage.setItem(SAMPLE_KEY, JSON.stringify(samples));
}

function addSample(product) {
  const samples = getSamples();
  if (samples.length >= MAX_SAMPLES) return { success: false, reason: 'max' };
  if (samples.find(s => s.id === product.id)) return { success: false, reason: 'exists' };
  samples.push(product);
  saveSamples(samples);
  return { success: true };
}

function removeSample(id) {
  const samples = getSamples().filter(s => s.id !== id);
  saveSamples(samples);
}

// ============================================
// HEADER ICON UPDATE
// ============================================

function updateHeaderIcon() {
  const count = getSamples().length;

  const badge = document.getElementById('sample-header-badge');
  if (badge) {
    if (count === 0) {
      badge.style.display = 'flex';
      badge.textContent = '0';
    } else {
      badge.style.display = 'flex';
      badge.textContent = count;
    }
  }

  const text = document.getElementById('sample-header-text');
  if (text) {
    text.textContent = count === 0 ? 'No samples' : `${count} of ${MAX_SAMPLES}`;
  }
}

// ============================================
// DRAWER OPEN / CLOSE
// ============================================

function openDrawer() {
  renderDrawerItems();
  document.getElementById('sample-drawer').classList.add('open');
  document.getElementById('sample-drawer-overlay').classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeDrawer() {
  document.getElementById('sample-drawer').classList.remove('open');
  document.getElementById('sample-drawer-overlay').classList.remove('active');
  document.body.style.overflow = '';
}

// ============================================
// RENDER DRAWER ITEMS
// ============================================

function renderDrawerItems() {
  const samples = getSamples();
  const container = document.getElementById('sample-drawer-items');
  const counter = document.getElementById('sample-drawer-count');

  if (counter) {
    counter.innerHTML = `<span>${samples.length}/${MAX_SAMPLES}</span> samples selected`;
  }

  if (!container) return;

  if (samples.length === 0) {
    container.innerHTML = '<p class="sample-drawer__empty">No samples added yet.</p>';
    return;
  }

  container.innerHTML = samples.map(s => `
    <div class="sample-item" data-id="${s.id}">
      <img class="sample-item__img" src="${s.image}" alt="${s.title}" />
      <div class="sample-item__info">
        <div class="sample-item__title">${s.title}</div>
        <div class="sample-item__meta">
          ${s.colour ? `Colour: ${s.colour}` : ''}
          ${s.type ? `&nbsp;&nbsp;Type: ${s.type}` : ''}
        </div>
        <button class="sample-item__remove" onclick="handleRemove('${s.id}')">Remove</button>
      </div>
    </div>
  `).join('');
}

function handleRemove(id) {
  removeSample(id);
  renderDrawerItems();
  updateAllAddButtons();
  updateHeaderIcon();
}

// ============================================
// UPDATE PRODUCT PAGE BUTTONS
// ============================================

function updateAllAddButtons() {
  const samples = getSamples();
  const ids = samples.map(s => s.id);
  const count = samples.length;

  document.querySelectorAll('[data-sample-btn]').forEach(btn => {
    const pid = btn.getAttribute('data-sample-btn');
    const isAdded = ids.includes(pid);

    const labelEl = btn.querySelector('.btn-label');
    const countEl = btn.querySelector('.btn-count');

    if (isAdded) {
      btn.classList.add('already-added');
      if (labelEl) labelEl.textContent = 'View Samples';
    } else {
      btn.classList.remove('already-added');
      if (labelEl) labelEl.textContent = 'Get Sample';
    }

    if (countEl) {
      countEl.textContent = `${count}/${MAX_SAMPLES}`;
      countEl.style.display = 'inline-flex';
    }
  });

  document.querySelectorAll('[data-sample-cta-count]').forEach(el => {
    el.textContent = `${count}/${MAX_SAMPLES}`;
  });

  updateHeaderIcon();
}

// ============================================
// HANDLE "ADD TO SAMPLE" CLICK
// ============================================

function handleAddToSample(btn) {
  const product = {
    id: btn.getAttribute('data-product-id'),
    title: btn.getAttribute('data-product-title'),
    image: btn.getAttribute('data-product-image'),
    colour: btn.getAttribute('data-product-colour') || '',
    type: btn.getAttribute('data-product-type') || '',
    url: btn.getAttribute('data-product-url') || '',
  };

  const samples = getSamples();

  if (samples.find(s => s.id === product.id)) {
    openDrawer();
    return;
  }

  if (samples.length >= MAX_SAMPLES) {
    alert(`You can only add up to ${MAX_SAMPLES} free samples.`);
    return;
  }

  addSample(product);
  updateAllAddButtons();
  openDrawer();
}

// ============================================
// REDIRECT TO FORM PAGE
// ============================================

function goToRequestPage() {
  window.location.href = '/pages/request-a-free-sample';
}

// ============================================
// DOM READY
// ============================================

document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.getElementById('sample-drawer-overlay');
  if (overlay) overlay.addEventListener('click', closeDrawer);

  const closeBtn = document.getElementById('sample-drawer-close');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  const continueBtn = document.getElementById('sample-drawer-continue');
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);

  const requestBtn = document.getElementById('sample-drawer-request');
  if (requestBtn) requestBtn.addEventListener('click', goToRequestPage);

  updateAllAddButtons();
  updateHeaderIcon();
});